<template>
    <v-text-field
        ref="textField"
        :value="strValue"
        :rules="rules"
        :error="error"
        :error-messages="errorMessages"
        :label="label"
        :disabled="disabled"
        :prefix="prefix"
        :suffix="suffix"
        :clearable="clearable"
        :outlined="outlined"
        :filled="filled"
        :prepend-icon="prependIcon"
        :append-icon="appendIcon"
        :hide-details="hideDetails"
        :dense="dense"
        :single-line="singleLine"
        :unsigned="unsigned"
        :hint="hint"
        :persistent-hint="persistentHint"
        clear-icon="fal fa-times"
        @blur="$emit('blur', $event)"
        @keypress="onKeyPress($event)"
        @input="updateValue($event)"
        @paste="onKeyPress($event)"
        @keyup="$emit('keyup', $event)"
        @keydown="$emit('keydown', $event)"
        @click="$emit('click', $event)"
    />
</template>

<script>
export default {
    props: {
        value: {
            type: [Number, String],
            default: null
        },
        precision: {
            type: Number,
            default: 2
        },
        rules: {
            type: Array,
            default: () => []
        },
        error: {
            type: Boolean,
            default: false
        },
        errorMessages: {
            type: Array,
            default: () => []
        },
        label: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        prefix: {
            type: String,
            default: null
        },
        suffix: {
            type: String,
            default: null
        },
        clearable: {
            type: Boolean,
            default: false
        },
        prependIcon: {
            type: String,
            default: undefined
        },
        appendIcon: {
            type: String,
            default: undefined
        },
        outlined: {
            type: Boolean,
            default: false
        },
        filled: {
            type: Boolean,
            default: false
        },
        hideDetails: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        singleLine: {
            type: Boolean,
            default: false
        },
        unsigned: {
            type: Boolean,
            default: false
        },
        max: {
            type: Number,
            default: null
        },
        min: {
            type: Number,
            default: null
        },
        hint: {
            type: String,
            default: null
        },
        persistentHint: {
            type: Boolean,
            default: false
        },
        useString: {
            type: Boolean,
            default: false
        },
    },

    mounted() {
        this.strValue = this.value !== 0 && !!this.value
            ? parseFloat(this.value).toString()
            : (this.value === 0 ? '0' : null)
    },

    data: () => {
        return {
            strValue: null,
        }
    },

    watch: {
        value(val) {
            if (parseFloat(this.strValue) != val) {
                if (this.strValue === '-' && val === 0) {
                    this.strValue = '-0';
                    return;
                }

                this.strValue = val === 0 || !!val ? parseFloat(val).toString() : null;
            }
        }
    },

    methods: {
        updateValue(event) {
            if (event !== null && event !== '' && event !== '-') {
                this.setValue(parseFloat(event));
            } else {
                this.setValue(null);
            }
        },

        onKeyPress(event){

            let key = event.key;

            if (!['-', '.', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(key)) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }

            if (key === '.' && this.strValue === null) {
                this.strValue = '0.';
                this.setValue(0);
                event.preventDefault();
                event.stopPropagation();
                return;
            }

            if (key === '.' && this.strValue.indexOf('.') !== -1) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }

            if (key === '-') {
                event.preventDefault();
                event.stopPropagation();

                if(this.unsigned) return

                if ((!this.strValue && this.strValue !== 0) || this.strValue === '-') {
                    this.strValue = '-';
                    return;
                }

                if (this.strValue === '0') {
                    this.strValue = '-0';
                    return;
                }

                this.setValue(-1 * this.value);
                return;
            }

            const inputEl = this.$refs.textField.$refs.input;

            if(this.max && parseFloat(inputEl.value + event.key) > this.max) {
                event.preventDefault();
                event.stopPropagation();
            }

            if(this.min && parseFloat(inputEl.value + event.key) < this.min) {
                event.preventDefault();
                event.stopPropagation();
            }

            const isSelected = inputEl && this.strValue && inputEl.selectionStart === 0 && inputEl.selectionEnd === this.strValue.length

            let decimalPart = this.value !== null ? parseFloat(this.value).toString().split('.')[1] : null;

            if (decimalPart && decimalPart.length >= this.precision && !isSelected) {
                event.preventDefault();
                event.stopPropagation();
            }
        },

        setValue(value) {
            if (value !== null) {
                value = parseFloat(value);
                if (this.useString) {
                    value = value.toString();
                }

                this.$emit('input', value);
            } else {
                this.$emit('input', null);
            }
        },

        focus() {
            if (this.$refs.textField && !this.$refs.textField.isFocused) {
                this.$refs.textField.focus();
                this.selectAll();
            }
        },

        selectAll() {
            if(this.$refs.textField) {
                this.$refs.textField.$refs.input.setSelectionRange(0, 10000);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
